import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import HomeView from '../views/receiptview';

const HomeController = () => {
    const [data, setData] = useState(null);
    const [deals, setDeals] = useState(null);
    const [products, setProducts] = useState(null);
    const [bannerTop, setbannerTop] = useState(null);
    const [bannerBottom, setbannerBottom] = useState(null);
    const [taxOrganization, setTaxOrganization] = useState([]);
    const [error, setError] = useState(null);
    const { code } = useParams();

    useEffect(() => {
        const fetchData = async () => {
            try {
                if (!code || code === '') {
                    console.error('Code parameter is missing');
                    return;
                }


                const response = await fetch(`${process.env.REACT_APP_BASE_URL}/get-receipt/?code=${code}`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                    }
                });
                if (!response.ok) {
                    throw new Error('Failed to fetch data');
                }
                const jsonData = await response.json();
                // console.log('API Response:', jsonData); // Log the API response
                setData(jsonData.data);
                setbannerTop(jsonData.bannerTop);
                setbannerBottom(jsonData.bannerBottom);
                setTaxOrganization(jsonData.taxOrganization);
                setDeals(jsonData.deals);
                setProducts(jsonData.products);
            } catch (error) {
                console.error('Error fetching data:', error);
                setError(error);
            }
        };

        fetchData();
    }, [code]);
    // console.log('deals', deals);
    // console.log('products', products);

    return <HomeView data={data} bannerTop={bannerTop} bannerBottom={bannerBottom} taxOrganization={taxOrganization} deals={deals} products={products} error={error} />;
};

export default HomeController;